module.exports = __webpack_public_path__ + "img/header-1023.3e39f54.png";